// @ts-nocheck
class WIcartDrawer extends HTMLElement{
    constructor() {
        super();
        this.addEventListener('click', this.closeCart.bind(this));
        this.addEventListener('click', this.cartBgclick.bind(this));
        document.addEventListener('openCart', this.openCart.bind(this));
    }
    connectedCallback(){
        this.clickOncart();
           document.addEventListener('opencart', ()=>{
            this.openCart();
            let loadingCartBlock = document.querySelector('.WI_loadingCartItemBlock');
            let emptyCart =  document.querySelector('.WI_cartDrawerin_cart_empty');
            console.log(loadingCartBlock);
                if (loadingCartBlock) {
                    loadingCartBlock.style.display = "block";
                }
                if (emptyCart) {
                    emptyCart.style.display = "none";
                }
        })
    }

    clickOncart() {
        document.querySelectorAll('.WI_cart-link').forEach(cart=>{
            cart.addEventListener('click', (e)=>{
            e.preventDefault();
            this.openCart();
        });
        });
    }
    openCart() {
        let cartDrawer = this.querySelector('.WI_cartDrawerin');
        let cartDrawerUpsell = this.querySelector('.WI_cartDrawerin_upsell');
        this.style.display = "flex";
        setTimeout(() => {
           document.dispatchEvent(new CustomEvent("open:background", {bubbles: true}));
            cartDrawer.classList.add('WI_cartDrawerinActive');
        },10);
        
    }
    closeCart(event) {
        if (event.target.matches('.WI_cartDrawerCls')) {
            let cartDrawer = this.querySelector('.WI_cartDrawerin');
            setTimeout(() => {
                
                cartDrawer.classList.remove('WI_cartDrawerinActive');
                setTimeout(() => {
                    document.dispatchEvent(new CustomEvent("close:background", {bubbles: true}));
                    this.style.display = "none";
                },310);
            },10);
        }
    }
    cartBgclick(event) {
        if (event.target.matches('wi-cartdrawer')) {
            let cartDrawer = this.querySelector('.WI_cartDrawerin');
            setTimeout(() => {
                this.style.backgroundColor = 'rgba(0,0,0,0)';
                cartDrawer.classList.remove('WI_cartDrawerinActive');
                setTimeout(() => {
                    document.dispatchEvent(new CustomEvent("close:background", {bubbles: true}));
                    this.style.display = "none";
                },310);
            },10);
        }
    }
}
customElements.define("wi-cartdrawer", WIcartDrawer);

class WIcartDrawerInfo extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('click', this.incQuantity.bind(this));
        this.addEventListener('click', this.decQuantity.bind(this));
        this.addEventListener('click', this.revQuantity.bind(this));
    };
    connectedCallback() {
        this.quickAddUpdate();
        // this.defaultATC();
        // this.totalSaving();
        // this.freeShipping();
        this.cartBubble();
        this.cartDiscount();
    }

    async updateCart() {
        let res = await fetch('/?section_id=wi-cartdrawer');
        let text = await res.text();
        let html = document.createElement('div');
        html.innerHTML = text;
        let cartItems = html.querySelector('.WI_cartDrawerin_cart').innerHTML;
        document.querySelector('.WI_cartDrawerin_cart').innerHTML = cartItems;
        this.cartDiscount();
        // this.totalSaving();
        // this.freeShipping();
        this.cartBubble();
        let cartDrawer = document?.querySelector('.WI_cartDrawerin');
        if(cartDrawer) {
            if (!cartDrawer.classList.contains('WI_cartDrawerinActive')) {
                document.dispatchEvent(new CustomEvent('opencart', {bubbles: true}));
            }
        }
    }
    // update cart bubble 
    async cartBubble() {
        try {
            let res = await fetch('/cart.js');
            let data = await res.json();
            let quantityItem = data.item_count;
            let cartBubble = document.querySelector('.WI_cartBubble');
            if (quantityItem > 0) {
                cartBubble.style.opacity = "1";
                cartBubble.innerHTML = quantityItem;
            } else {
                cartBubble.style.opacity = "0";
                cartBubble.innerHTML = 0;
            }
        } catch (error) {
            console.log("cart bubble", error);
        }
    }

    quickAddUpdate() {
        document.addEventListener('updateCart', () => {
            this.updateCart();
        })
    }
    async incQuantity(event) {
        if (event.target.matches('.WI_cartDrawer_plus')) {
            let rOOt = event.target;
            let keyID = rOOt.parentElement.parentElement.parentElement.parentElement.parentElement.getAttribute('data-itemKey');
            let quantity = Number(rOOt.parentElement.parentElement.querySelector('input').value);
            let newQuantity = quantity + 1;      rOOt.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector('.WI_cartLoadingin').classList.add('WI_cartLoadingActive');
            await fetch('/cart/update.js', {
                method: 'post',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    updates: {
                        [keyID]: newQuantity
                    }
                })
            });
            this.updateCart();
        }
    }
    async decQuantity(event) {
        if (event.target.matches('.WI_cartDrawer_minus')) {
            let rOOt = event.target;
            let keyID = rOOt.parentElement.parentElement.parentElement.parentElement.parentElement.getAttribute('data-itemKey');
            let quantity = Number(rOOt.parentElement.parentElement.querySelector('input').value);
            let newQuantity = quantity - 1;
            rOOt.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector('.WI_cartLoadingin').classList.add('WI_cartLoadingActive');

            await fetch('/cart/update.js', {
                method: 'post',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    updates: {
                        [keyID]: newQuantity
                    }
                })
            });
            this.updateCart();
        }
    }
    async revQuantity(event) {
        if (event.target.matches('.cartDrawerRemove')) {
            let rOOt = event.target;
            let keyID = rOOt.parentElement.parentElement.parentElement.parentElement.getAttribute('data-itemKey');
            let quantity = 0;
            rOOt.parentElement.parentElement.parentElement.parentElement.querySelector('.WI_cartLoadingin').classList.add('WI_cartLoadingActive');
            await fetch('/cart/update.js', {
                method: 'post',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    updates: {
                        [keyID]: quantity
                    }
                })
            });
            this.updateCart();
        }
    }

    // Adding cart discount 
    cartDiscount() {
        let disValue = this?.querySelector('#WI_cartDiscount');
        let disBtn = this?.querySelector('#WI_cartDiscount_btn');
        if (!disBtn) {
            return;
        }
        disBtn.addEventListener('click', async () => {
            if (!disValue.value) {
                return;
            }
            this.querySelector('.WI_loadingSpiner').style.display = "flex";
            let updates = { discount: disValue.value};
            try {
                await fetch(window.Shopify.routes.root + 'cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ discount: disValue.value })
                })
                    this.updateCart();
            } catch (error) {
                console.log("Cart discount error - "+error);
            }
            // document.dispatchEvent(new CustomEvent('updateCart', {
            //     bubbles: true
            // }));
        });
    };
    
    defaultATC() {
        const allForm = document.querySelectorAll('form[action="/cart/add"]');
        allForm.forEach(elem => {
            elem.addEventListener('submit', async (e) => {
                e.preventDefault();
                let loadingCartBlock = document.querySelector('.WI_loadingCartItemBlock');
                let emptyCart = document.querySelector('.WI_cartDrawerin_cart_empty');
                document.dispatchEvent(new CustomEvent('openCart', {
                    bubbles: true
                }));
            })
        });
    }

}
customElements.define("wi-cartdrawer-info", WIcartDrawerInfo);